import { AnalysisFileType } from "../../../types/analysisFileTypes";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../../scaffold/ui/LinkTypes";
import GenericAnalysisFilesAdminPage from "./GenericAnalysisFileAdminPage";


export default function BoughtVouchersAnalysisFilesAdminPage() {
    return <GenericAnalysisFilesAdminPage
        fileType={AnalysisFileType.BoughtVouchersAnalysisFile}
        title={SidebarLinkTypes.superAdminAnalysisFilesBoughtVouchers}
        link={SidebarLinkPathTypes.superAdminAnalysisFilesBoughtVouchers}
    />
}